<template>
  <el-dialog title="修改路由配置" :visible.sync="visible" width="530px" :before-close="closeDialog">
    <el-form v-if="routeConfig" ref="form" :model="routeConfig" inline
    :rules="rules" style="width:430px" label-width="130px">
      <el-form-item label="路由地址" prop="route">
        <el-input v-model="routeConfig.route" disabled></el-input>
      </el-form-item>
      <el-form-item label="图1活体开关" prop="img1CheckAlive" style="width: 50%">
        <el-switch
          v-model="routeConfig.img1CheckAlive"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="图2活体开关" prop="img2CheckAlive">
        <el-switch
          v-model="routeConfig.img2CheckAlive"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="对比模式" prop="compareMode">
        <el-radio v-model="routeConfig.compareMode" :label="1">生活照模式</el-radio>
        <el-radio v-model="routeConfig.compareMode" :label="2">证件照模式</el-radio>
      </el-form-item>
      <el-form-item align="center" style="width: 100%">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { rules } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    routeConfig: {
      type: Object
    } 
  },
  data() {
    return {
      rules: {
        route:          [rules.required()],
        img1CheckAlive: [rules.required()],
        img2CheckAlive: [rules.required()],
        compareMode:    [rules.required()]
      }
    };
  },
  methods: {
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let res = await this.$request(this.$api.routeConfig.update(this.routeConfig));
      this.$message.success("修改路由配置成功");
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('update:visible', false)
      this.$emit('load')
    }
  }
};
</script>

<style>
</style>

